import "./Loading.css";

export const Loading = () => {
  return (
    <div className="modal">
      <div className="loader"></div>
    </div>
  );
};
